(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const swiperContainers = document.querySelectorAll('.card_media.swiper-container');
    
    swiperContainers.forEach(function(container) {
      const swiper = new Swiper(container, {
        loop: false,
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 0,
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["segment-button"] && !Shopify.designMode) return;
  try {
    const segments = document.querySelectorAll('.segment');
        
    segments.forEach(segment => {
        segment.addEventListener('click', function() {
            segments.forEach(s => s.classList.remove('active'));
            this.classList.add('active');
        });
    });
  } catch(e) { console.error(e); }
})();

})();
